export * from './date-format.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/date-format/index.ts